export default __webpack_public_path__ + "static/media/Shopify.533117d5.svg";